import * as Yup from 'yup';

export const mapPropsToValues = ({ values }) => ({
  guestNumber: values?.guests || '',
  termsAndConditionsHasAccepted: false,
});

export const validationSchema = Yup.object().shape({
  termsAndConditionsHasAccepted: Yup.boolean().required('Requerido'),
  guestNumber: Yup.string().required('Requerido'),
});
